type DefendIQMarkProps = {
  size?: number;
  className?: string;
  title?: string;
};

/**
 * The DefendIQ monogram (docs/DefendIQ_Premium_BUI_Dual_Theme_Claude_Code_Brief.md, Section 3) —
 * a rounded-square execution boundary with a D cut-out, a Q-tail node, and a single orange arc
 * marking authorised scope. Replaces BrandShield everywhere: no shield, padlock, or emblem shape.
 * `stroke="currentColor"` on the frame/D lets each call site set light/dark line color via the
 * surrounding text color; the Q-tail and scope arc stay BUI-orange in both themes.
 */
export function DefendIQMark({ size = 32, className = '', title = 'DefendIQ' }: DefendIQMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={title}
    >
      <defs>
        <linearGradient id="defendiq-accent" x1="12" y1="10" x2="53" y2="54" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFB648" />
          <stop offset="1" stopColor="#F47A17" />
        </linearGradient>
      </defs>

      <rect x="7" y="7" width="50" height="50" rx="14" stroke="currentColor" strokeWidth="3" />

      <path
        d="M21 19H32.5C41.6 19 47 24.1 47 32C47 40.1 41.6 45 32.5 45H21V19Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M40.5 40.5L49 49" stroke="url(#defendiq-accent)" strokeWidth="4" strokeLinecap="round" />

      <circle cx="51" cy="51" r="4" fill="#F47A17" />

      <path d="M7 24V18C7 11.9 11.9 7 18 7H24" stroke="url(#defendiq-accent)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
